import { render, staticRenderFns } from "./male.vue?vue&type=template&id=4c0f8b44&scoped=true"
import script from "./male.vue?vue&type=script&lang=js"
export * from "./male.vue?vue&type=script&lang=js"
import style0 from "./male.vue?vue&type=style&index=0&id=4c0f8b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f8b44",
  null
  
)

export default component.exports